import React from 'react'
import moment, { Moment } from 'moment-timezone'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DesktopDatePicker, DesktopDatePickerProps } from '@mui/x-date-pickers/DesktopDatePicker'
import { useTenantTimezone } from './contexts'
import { normalizeToTenantTZ } from '../../utils/tenantDateTime'

interface TenantDatePickerProps extends Omit<DesktopDatePickerProps<Moment>, 'onChange' | 'value'> {
  value: Moment | null
  onChange: (value: Moment | null) => void
}

const TenantDatePicker: React.FC<TenantDatePickerProps> = ({ value, onChange, ...rest }) => {
  const tz = useTenantTimezone()

  const { disablePast, disableFuture, minDate, maxDate, ...other } = rest
  const tenantToday = moment.tz(tz).startOf('day')
  const effectiveMin = disablePast
    ? (minDate && minDate.isAfter(tenantToday) ? minDate : tenantToday)
    : minDate
  const effectiveMax = disableFuture
    ? (maxDate && maxDate.isBefore(tenantToday) ? maxDate : tenantToday.clone().endOf('day'))
    : maxDate

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
      <DesktopDatePicker
        {...other}
        minDate={effectiveMin}
        maxDate={effectiveMax}
        value={value}
        onChange={picked => onChange(normalizeToTenantTZ(picked, tz))}
      />
    </LocalizationProvider>
  )
}

export default TenantDatePicker
